import { inject, Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { UserService } from '../../providers/auth/user.service';
import { Location } from '@capacitor-community/background-geolocation';
import { TypeActiviteInterne } from '../../models/activite-interne/activite-interne.model';
import { ActiviteEnCoursStorageProvider } from './activite-en-cours-storage-provider.service';

export type ActiviteEnCours = {
  id: string;
  type?: ActiviteEnCoursType;
  type_ot?: string;
  type_activite_interne?: TypeActiviteInterne;
  libelle?: string;
  site_id?: string;
  site_name?: string;
  id_sti?: string;
  id_tempo?: string;
  siteLocations?: Location[];
};

export type ActiviteEnCoursType = 'ot' | 'activite-interne' | 'renfort';

@Injectable({
  providedIn: 'root',
})
export class ActiviteEnCoursService {
  private readonly userService: UserService = inject(UserService);
  private readonly activiteEnCoursStorageProvider = inject(ActiviteEnCoursStorageProvider);
  activiteEnCours$: BehaviorSubject<ActiviteEnCours> = new BehaviorSubject(null);

  constructor() {}

  async demarrerActiviteEncours(activiteEnCours: ActiviteEnCours) {
    console.log("Démarrage de l'activite " + activiteEnCours.id);
    await this.activiteEnCoursStorageProvider.saveActiviteEnCours(activiteEnCours);
    this.activiteEnCours$.next(activiteEnCours);
  }

  async reloadActivite() {
    console.log('reloadActivite for intervenant ' + this.userService.getId());
    const activiteEnCours: ActiviteEnCours = await this.activiteEnCoursStorageProvider.getActiviteEnCours();
    if (activiteEnCours) {
      console.log('Activite retrouvée: ' + activiteEnCours.id);
      this.activiteEnCours$.next(activiteEnCours);
      return activiteEnCours;
    }
    return null;
  }

  async supprimerActiviteEnCours(id: string) {
    const activiteEnCours: ActiviteEnCours = await this.getActiviteEnCours();
    if (activiteEnCours?.id === id) {
      console.log("Suppression de l'activite " + id);
      await this.activiteEnCoursStorageProvider.removeActiviteEnCours();
      this.activiteEnCours$.next(null);
    }
  }
  async supprimerActiviteEnPause(id: string) {
    await this.activiteEnCoursStorageProvider.supprimerActiviteEnPause(id);
  }
  async getActiviteEnPauseExists(idActivite: string): Promise<boolean> {
    let activiteEnCours: ActiviteEnCours = await this.activiteEnCoursStorageProvider.getActiviteEnPause(idActivite);
    return !!activiteEnCours;
  }
  async getActiviteEnPause(idActivite: string): Promise<ActiviteEnCours> {
    return await this.activiteEnCoursStorageProvider.getActiviteEnPause(idActivite);
  }
  async getActiviteEnCours(): Promise<ActiviteEnCours> {
    return await this.activiteEnCoursStorageProvider.getActiviteEnCours();
  }

  async updateActiviteEnCours(newActiviteEnCours: ActiviteEnCours) {
    const activiteEnCours: ActiviteEnCours = await this.activiteEnCoursStorageProvider.getActiviteEnCours();
    if (activiteEnCours?.id === newActiviteEnCours.id) {
      console.log("Mise à jour de l'activite en cours " + activiteEnCours.id);
      await this.activiteEnCoursStorageProvider.saveActiviteEnCours(newActiviteEnCours);

      this.activiteEnCours$.next(newActiviteEnCours);
    }
  }
  async mettreActiviteEnPause(id: string) {
    const activiteEnCours: ActiviteEnCours = await this.getActiviteEnCours();
    if (activiteEnCours?.id === id) {
      console.log("Mise en pause de l'activite " + activiteEnCours.id);
      await this.activiteEnCoursStorageProvider.saveActiviteEnPause(activiteEnCours);
      await this.supprimerActiviteEnCours(id);
    }
  }

  async reprendreActiviteEnPause(id: string): Promise<ActiviteEnCours> {
    const activiteEnPause: ActiviteEnCours = await this.getActiviteEnPause(id);
    if (activiteEnPause) {
      await this.supprimerActiviteEnPause(id);
      await this.demarrerActiviteEncours(activiteEnPause);
      return activiteEnPause;
    }
    return null;
  }
}
